import { Outlet } from "react-router-dom";
import NavBar from "./NavBar";
import Foot from "./Foot"
import { Row } from 'react-materialize'

const Layout = () => {
    return (
        <div>
            <NavBar />
            <Row className="App-header" >
                <Outlet />
            </Row >
            <Foot></Foot>
        </div>
    )
};

export default Layout;